import * as api from 'service/ErplyAPI/config';
import { getServiceEndpoints } from 'service/ErplyAPI/getServiceEndpoints';
import { SERVICE_ENDPOINTS } from 'utils';

import * as types from './types';

/** Fetch and save in redux the currencies for this account */
export const fetchCurrencies = () => async (dispatch) => {
  dispatch({ type: types.FETCH_CURRENCY.START });
  try {
    const { records } = await api.getCurrency();
    dispatch({ type: types.FETCH_CURRENCY.SUCCESS, payload: records });
  } catch (err) {
    dispatch({ type: types.FETCH_CURRENCY.ERROR, payload: err.message });
  }
};

/**
 * Fetch service endpoints
 *
 */
export const fetchServiceEndpoints = () => async (dispatch) => {
  dispatch({ type: types.FETCH_SERVICE_ENDPOINTS.START });
  try {
    const { records } = await getServiceEndpoints();
    if (records.length) {
      const payload = records[0];
      dispatch({ type: types.FETCH_SERVICE_ENDPOINTS.SUCCESS, payload });
      localStorage.setItem(SERVICE_ENDPOINTS, JSON.stringify(payload));
    }
  } catch (err) {
    console.error(err);
    dispatch({ type: types.FETCH_SERVICE_ENDPOINTS.ERROR });
  }
};

/** Save an individual setting (key-value pair) in Erply API */
export const saveSetting = (params) => async (dispatch) => {
  dispatch({ type: types.SAVE_SETTINGS.START });
  try {
    await api.saveConfParameter(params);
    dispatch({
      type: types.SAVE_SETTINGS.SUCCESS,
      payload: { [params.parameterName]: params.parameterValue },
    });
  } catch (err) {
    console.error(err);
    dispatch({ type: types.SAVE_SETTINGS.ERROR, payload: err });
  }
};

/**
 * Fetch the settings for this account from Erply API
 * Save any missing settings back to the erply API
 * Save all the settings in redux
 * */
export const setSettings = () => async (dispatch) => {
  dispatch({ type: types.SET_SETTINGS.START });
  try {
    const response = await api.getConfParameters();
    let [data] = response.records;
    const defaultSettings = [
      {
        key: 'pos_default_language',
        defaultValue: data.default_language,
      },
      {
        key: 'use_default_language',
        defaultValue: true,
      },
      {
        key: 'pos_allow_sale_cash',
        defaultValue: 1,
      },
      {
        key: 'pos_allow_sale_card',
        defaultValue: 1,
      },
      {
        key: 'pos_allow_sale_giftcard_serial',
        defaultValue: 1,
      },
      {
        key: 'pos_allow_sale_giftcard_regular',
        defaultValue: 1,
      },
      {
        key: 'pos_allow_sale_storecredit',
        defaultValue: 1,
      },
      {
        key: 'pos_allow_sale_check',
        defaultValue: 1,
      },
      {
        key: 'pos_allow_sale_tip',
        defaultValue: 1,
      },
      {
        key: 'pos_allow_return_receipt_cash',
        defaultValue: 1,
      },
      {
        key: 'pos_allow_return_receipt_card',
        defaultValue: 1,
      },
      {
        key: 'pos_allow_return_receipt_giftcard_serial',
        defaultValue: 1,
      },
      {
        key: 'pos_allow_return_receipt_giftcard_regular',
        defaultValue: 1,
      },
      {
        key: 'pos_allow_return_receipt_storecredit',
        defaultValue: 1,
      },
      {
        key: 'pos_allow_return_receipt_check',
        defaultValue: 1,
      },
      {
        key: 'pos_allow_return_cash',
        defaultValue: 1,
      },
      {
        key: 'pos_allow_return_card',
        defaultValue: 1,
      },
      {
        key: 'pos_allow_return_giftcard_serial',
        defaultValue: 1,
      },
      {
        key: 'pos_allow_return_giftcard_regular',
        defaultValue: 1,
      },
      {
        key: 'pos_allow_return_storecredit',
        defaultValue: 1,
      },
      {
        key: 'pos_allow_return_check',
        defaultValue: 1,
      },
    ];
    const ensureExistance = async ({ key, defaultValue }) => {
      if (!data[key]) {
        await api.saveConfParameter({
          parameterName: key,
          parameterValue: defaultValue,
        });
        data = { ...data, [key]: defaultValue };
      }
    };
    // eslint-disable-next-line no-restricted-syntax
    for (const { key, defaultValue } of defaultSettings) {
      // eslint-disable-next-line no-await-in-loop
      await ensureExistance({ key, defaultValue });
    }

    const settings = {
      default_language: data.default_language,
      use_default_language: data.use_default_language,
      languages: data.languages,
      pos_default_language: data.pos_default_language,
      account_links: data.account_links,
      touchpos_out_of_stock_warning: data.touchpos_out_of_stock_warning,
      ...Object.assign(
        {},
        ...Object.entries(data)
          .filter(([key]) => !key.match(/^CONFIGURATION: /))
          .map(([key, value]) => {
            if (value === '0' || value === '1') {
              return { [key]: parseInt(value, 10) };
            }
            if (value === 'true' || value === 'false') {
              return { [key]: value === 'true' };
            }
            return { [key]: value };
          }),
      ),
    };
    dispatch({ type: types.SET_SETTINGS.SUCCESS, payload: settings });
  } catch (err) {
    console.error(err);
    dispatch({ type: types.SET_SETTINGS.ERROR, payload: err });
  }
};
